import React from "react";
import { View, Image, StyleSheet, ScrollView } from "react-native"
import { useSelector } from "react-redux";
import styles from "../../styles";
import { addBookmark } from "../../assets";
import { global } from "../../const";
import Header, { HeaderRight } from "../../components/Header";
import { setCookie } from "../../functions";
import { PrimaryTitle } from "../../components/labels";
import Button from "../../components/form/Button";
import localize from "../../localize";


export default function BookmarkContainer(props) {
    const isLogin = useSelector(({ auth }) => auth.isLogin)
    const _bookmarkDid = (status) => {
        if (status) {
            setCookie(global.IS_BOOKMARK_ADDED, 1, 365);
        }
        props.history.push(isLogin ? "/dashboard" : "/SignIn")
    }

    return (
        <View style={styles.container}>
            <Header
                title="Make a bookmark"
                right={(<HeaderRight onPress={() => _bookmarkDid(false)} />)}
            />
            <ScrollView style={pageStyles.container}>
                <PrimaryTitle>
                    {localize.Make_a_bookmark_now_in_your_mobile_browser_so_you_wont_forget_this_website}
                </PrimaryTitle>
                <Image
                    source={addBookmark}
                    style={pageStyles.bookmarkImg}
                    resizeMode="contain"
                />
                <PrimaryTitle size={14}>
                    {localize.Bookmarks_at_the_top_of_the_browser_window}
                </PrimaryTitle>
                <View style={{ height: 30 }} />
                <Button
                    title={localize.I_did_this}
                    size="small"
                    onPress={() => _bookmarkDid(true)}
                />

            </ScrollView>
        </View>
    );
}

const pageStyles = StyleSheet.create({
    bookmarkImg: {
        width: "100%",
        height: 250,
        marginVertical: 20
    },
    container: {
        padding: 15
    }
})